import { isPathLookupEdgeData } from '@ipfabric/utils';
import type { GraphRendererPlugin } from 'components/Graph/GraphApp/plugins/GraphRendererPlugin';
import { getPacketPath } from 'components/Graph/helpers/getPacketPath';

export const highlightPacketPath: GraphRendererPlugin = (pluginInterface) => {
  pluginInterface.events.addListener('edgeAdded', ({ edge, edgeData, id }) => {
    if (!isPathLookupEdgeData(edgeData)) {
      return;
    }

    edge.on('mouseover', () => {
      // load current edge data from state since they may be updated since edge was added
      const graphData = pluginInterface.getGraphData();
      const edgeRecord = graphData.edges;
      const currentEdgeData = edgeRecord[id];
      if (!currentEdgeData || !isPathLookupEdgeData(currentEdgeData)) {
        return;
      }
      const { nodeIds, edgeIds } = getPacketPath(
        currentEdgeData,
        edgeRecord,
        graphData,
      );
      pluginInterface.events.emit('highlightGraphPart', {
        clear: true,
        edges: Array.from(edgeIds.values()),
        nodes: Array.from(nodeIds.values()),
      });
    });
    edge.on('mouseout', () => {
      pluginInterface.events.emit('unhighlightGraphPart');
    });
  });
};
